import { DeleteOutlined } from "@ant-design/icons";
import { type Qualification } from "@src/appV2/Admin/Qualifications/types";
import { Button } from "antd";

import { HOLIDAY_DIFFERENTIAL, HOLIDAY_FEE_TYPE_OPTIONS } from "./constants";
import { type HolidayIncrement, type QualificationHolidayFeeOverrideRow } from "./types";

export function renderIncrement(value: number, record: QualificationHolidayFeeOverrideRow): string {
  if (record.type === HOLIDAY_DIFFERENTIAL.CHARGE_RATE_MULTIPLIER) {
    return `${value}x`;
  }
  return `$${value}/hr`;
}

export interface GetColumnsParams {
  qualifications: Qualification[];
  isUpdating: boolean;
  onDelete: (record: QualificationHolidayFeeOverrideRow) => void;
}

export function getColumns(params: GetColumnsParams) {
  const { qualifications, isUpdating, onDelete } = params;

  return [
    {
      title: "Qualification",
      dataIndex: "qualification",
      key: "qualification",
      render: (value: string) => {
        const qualification = qualifications.find(
          (qualificationData) => qualificationData.attributes.name === value
        );
        return qualification?.attributes.displayLabel ?? value;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (value: HolidayIncrement) => {
        const option = HOLIDAY_FEE_TYPE_OPTIONS.find((opt) => opt.value === value);
        return option?.label ?? value;
      },
    },
    {
      title: "Increment",
      dataIndex: "increment",
      key: "increment",
      render: renderIncrement,
    },
    {
      title: "Action",
      key: "action",
      render: (_: unknown, record: QualificationHolidayFeeOverrideRow) => (
        <Button
          danger
          disabled={isUpdating}
          icon={<DeleteOutlined />}
          type="text"
          onClick={() => {
            onDelete(record);
          }}
        />
      ),
    },
  ];
}
